import React from 'react';
import { EnhancedPanel } from './components/EnhancedPanel';
import { CondensedPanel } from './components/CondensedPanel';
import { YesNoPanel } from './components/YesNoPanel';
import { DemoSection } from '../common/SectionNavigator';
import { DemoPage, DemoPageSection } from '../common/DemoLayout';

const sections: DemoSection[] = [
    { id: 'selectionPanelGroupDemo_enhanced', title: 'Enhanced Style' },
    { id: 'selectionPanelGroupDemo_condensed', title: 'Condensed Style' },
    { id: 'selectionPanelGroupDemo_yesNo', title: 'Yes / No Selection Panel Group' },
];

export const SelectionPanelGroupDemo: React.FC = () => {
    return (
        <DemoPage
            title='Selection Panel Group :'
            sections={sections}
        >
            <DemoPageSection
                id={sections[0].id}
                title='Enhanced Style (default)'
            >
                <EnhancedPanel />
            </DemoPageSection>
            <DemoPageSection
                id={sections[1].id}
                title='Condensed Style'
            >
                <CondensedPanel />
            </DemoPageSection>
            <DemoPageSection
                id={sections[2].id}
                title='Components that inherit from Selection Panel Group: Yes / No'
            >
                <YesNoPanel />
            </DemoPageSection>
        </DemoPage>
    );
};
